export const MEMBERSHIP_ALLOWED_STATUS = Object.freeze([
  'approved',
  'pending',
  'rejected',
  'incomplete',
]);

export const MEMBERSHIP_ALLOWED_STATUS_SET = new Set(MEMBERSHIP_ALLOWED_STATUS);

export const DEFAULT_REPORT_BUILDER_OPTIONS = Object.freeze({
  reportTypes: Object.freeze([
    Object.freeze({ value: 'membership', label: 'Membership Report' }),
    Object.freeze({ value: 'events', label: 'Event Attendance' }),
    Object.freeze({ value: 'venues', label: 'Venues Report' }),
    Object.freeze({ value: 'client-bookings', label: 'Client Bookings' }),
    Object.freeze({ value: 'revenue_bookings', label: 'Revenue (Bookings)' }),
    Object.freeze({ value: 'revenue_ids', label: 'Revenue (ID Requests)' }),
    Object.freeze({ value: 'tickets', label: 'Tickets Report' }),
    Object.freeze({ value: 'admin_access', label: 'Admin Access Report' }),
    Object.freeze({ value: 'security', label: 'Security Report' }),
    Object.freeze({ value: 'admin_roles', label: 'Admin Roles Report' }),
    Object.freeze({ value: 'system_activity', label: 'System Activity Report' }),
    Object.freeze({ value: 'website_access', label: 'Who Can Access Website' }),
    Object.freeze({ value: 'access_logs', label: 'Access Logs' }),
    Object.freeze({ value: 'system_usage', label: 'System Usage' }),
  ]),
  dateRanges: Object.freeze([
    Object.freeze({ value: '7d', label: 'Last 7 days' }),
    Object.freeze({ value: '30d', label: 'Last 30 days' }),
    Object.freeze({ value: '90d', label: 'Last 3 months' }),
    Object.freeze({ value: '12m', label: 'Last 12 months' }),
  ]),
  filters: Object.freeze([
    Object.freeze({ value: 'company', label: 'By Company' }),
    Object.freeze({ value: 'affiliation', label: 'By Union Affiliation' }),
    Object.freeze({ value: 'union-name', label: 'By Union Name' }),
    Object.freeze({ value: 'union', label: 'By Union Position' }),
    Object.freeze({ value: 'membership-breakdown', label: 'Membership Breakdown' }),
    Object.freeze({ value: 'status', label: 'By Status' }),
    Object.freeze({ value: 'region', label: 'By Region' }),
  ]),
  formats: Object.freeze([
    Object.freeze({ value: 'pdf', label: 'PDF Report' }),
    Object.freeze({ value: 'excel', label: 'Excel Worksheet' }),
    Object.freeze({ value: 'csv', label: 'CSV File' }),
    Object.freeze({ value: 'dashboard', label: 'Interactive Dashboard' }),
  ]),
});
